import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { getErrorMessage } from "@/lib/errorUtils";

export default function Login() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(phone, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(getErrorMessage(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-emerald-base flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-10 text-emerald-muted hover:text-gold transition" data-testid="brand-link">
          <Sparkles className="w-4 h-4 text-gold" />
          <span className="font-heading text-2xl text-white">SOS (Stan Of Style)</span>
        </Link>
        <div className="overline mb-3">Team & Guest Sign in</div>
        <h1 className="font-heading text-4xl text-white mb-3">Welcome back.</h1>
        <p className="text-emerald-muted mb-8 text-sm">Please enter your credentials to continue.</p>

        <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
          <div>
            <Label htmlFor="phone" className="text-emerald-muted text-xs uppercase tracking-widest">Phone</Label>
            <Input id="phone" data-testid="login-phone-input" type="tel" required value={phone} onChange={(e) => setPhone(e.target.value)}
              className="mt-2 bg-emerald-surface border-gold-subtle text-white focus:border-gold h-12" placeholder="enter your phone number" />
          </div>
          <div>
            <Label htmlFor="password" className="text-emerald-muted text-xs uppercase tracking-widest">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-2 bg-emerald-surface border-gold-subtle text-white focus:border-gold h-12" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit-btn"
            className="gold-button w-full h-12 rounded-md disabled:opacity-60">{loading ? "Signing in…" : "Sign in"}</button>
        </form>

        <p className="text-sm text-emerald-muted mt-8">
          New guest?  <Link to="/register" className="text-gold hover:underline" data-testid="link-register">Create a profile</Link>
          <span className="mx-2">·</span>
          <Link to="/reset-password" className="text-gold hover:underline" data-testid="link-reset-password">Forgot Password</Link>
        </p>
      </div>
    </div>
  );
}
